<template>
  <div id="messages-dialog" class="custom-modal">
    <div class="modal-body no-footer" :class="activeTab == '1' ? 'messages' : ''">
      <div class="messages-container">
        <div class="tab-switch">
          <span class="tab-item" :class="{ active: activeTab == 1 }" @click="activeTab = 1">{{ $t("contacts_hub.menu.messages.title") }}</span>
          <span class="tab-item" :class="{ active: activeTab == 2 }" @click="activeTab = 2">{{ $t("contacts_hub.menu.contacts.title") }}</span>
          <span class="tab-item" :class="{ active: activeTab == 3 }" @click="activeTab = 3">{{ $t("contacts_hub.menu.suggestions.title") }}</span>
        </div>
        <div class="message-hub" v-if="activeTab == 1">
          <div class="messaging-panel" :class="innerWidth <= 768 && this.activeChats == null ? '' : 'mobile-chat-passive'">
            <div
              class="messaging-item"
              v-for="(chat, index) in getMessages.sort(function(a, b) {
                return new Date(b.lastMessageReceived) - new Date(a.lastMessageReceived);
              })"
              :key="chat.id + '--' + index"
              @click="activateChat(chat)"
              :class="chat.unread > 0 ? 'unread' : ''"
            >
              <div class="messaging-profile-picture" :style="'background-image: url(' + $imageus + (getChatUser(chat).user.image != null ? getChatUser(chat).user.image : 'https://holacon.s3.eu-central-1.amazonaws.com/public/default-user.png') + '?width=100&height=100&mode=cover);'"></div>

              <div class="messaging-right">
                <p class="messaging-user-name">
                  {{ chat.title }}
                  <span v-if="chat.unread > 0">{{ chat.unread > 9 ? "+9" : chat.unread }}</span>
                </p>
                <p class="messaging-last-message" v-if="chat.lastMessage != null">{{ chat.lastMessage.messageText }}</p>
                <p class="messaging-moment" v-if="chat.messages.length > 0 && chat.lastMessageReceived != null">{{ moment(chat.lastMessageReceived).fromNow() }}</p>
              </div>
            </div>

            <infinite-loading @infinite="getData" :identifier="messageIdentifier">
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </div>
          <div class="chat-border"></div>
          <div class="chat-panel-container" :class="innerWidth <= 768 && this.activeChats != null ? '' : 'mobile-chat-active'">
            <div class="no-active-chat" v-if="this.activeChats == null">
              <lottie-animation v-if="this.activeChats == null && this.chatloading == false" path="./static/lottie/holacon-message-lottie.json" />
              <md-progress-spinner v-if="this.activeChats == null && this.chatloading == true" md-mode="indeterminate" :md-diameter="30" :md-stroke="3"></md-progress-spinner>

              <p>{{ $t("contacts_hub.menu.messages.select_message") }}</p>
            </div>

            <ChatPanel @close="close" :id="this.activeChats" v-if="this.activeChats != null" />
          </div>
        </div>
        <div class="container-inner" v-if="activeTab == 2">
          <Contacts v-if="activeTab == '2'" />
        </div>
        <div class="container-inner" v-if="activeTab == 3">
          <Suggestions v-if="activeTab == 3" />
        </div>
      </div>
      <!-- <transition name="el-fade-in" mode="out-in">
        <el-row class="messages-container">
          <el-tabs v-model="activeTab" @tab-click="handleClick" stretch>
            <el-tab-pane :label="$t('contacts_hub.menu.messages.title')" name="1">
              <div class="message-hub" v-if="getMessages.length != 0">
                <div class="messaging-panel" :class="innerWidth <= 768 && this.activeChats == null ? '' : 'mobile-chat-passive'">
                  <div
                    class="messaging-item"
                    v-for="chat in getMessages.sort(function(a, b) {
                      return new Date(b.lastMessageReceived) - new Date(a.lastMessageReceived);
                    })"
                    :key="chat.id"
                    @click="activateChat(chat)"
                    :class="chat.unread > 0 ? 'unread' : ''"
                  >
                    <div class="messaging-profile-picture" :style="'background-image: url(' + $imageus + (getChatUser(chat).user.image != null ? getChatUser(chat).user.image : 'https://holacon.s3.eu-central-1.amazonaws.com/public/default-user.png') + '?width=100&height=100&mode=cover);'"></div>

                    <div class="messaging-right">
                      <p class="messaging-user-name">
                        {{ chat.title }}<span v-if="chat.unread > 0">{{ chat.unread }}</span>
                      </p>
                      <p class="messaging-last-message" v-if="chat.lastMessage != null">{{ chat.lastMessage.messageText }}</p>
                      <p class="messaging-moment" v-if="chat.lastMessageReceived != null">{{ moment(chat.lastMessageReceived).fromNow() }}</p>
                    </div>
                  </div>

                  <infinite-loading @infinite="getData" :identifier="messageIdentifier">
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                  </infinite-loading>
                </div>

                <div class="chat-panel-container" :class="innerWidth <= 768 && this.activeChats != null ? '' : 'mobile-chat-active'">
                  <div class="no-active-chat" v-if="this.activeChats == null">
                    <lottie-animation v-if="this.activeChats == null && this.chatloading == false" path="./static/lottie/holacon-message-lottie.json" />
                    <md-progress-spinner v-if="this.activeChats == null && this.chatloading == true" md-mode="indeterminate" :md-diameter="30" :md-stroke="3"></md-progress-spinner>

                  

                    <p>{{ $t("contacts_hub.menu.messages.select_message") }}</p>
                  </div>

                  <ChatPanel @close="close" :id="this.activeChats" v-if="this.activeChats != null" />
                </div>
              </div>

              <NoData v-if="getMessages.length == 0" :title="$t('nodatakeys.messagehub.nodatatitle')" :description="$t('nodatakeys.messagehub.nodatadesc')" anim="holacon-message-lottie" :loading="loading == 'message'" :button="$t('nodatakeys.messagehub.nodatabutton')" @btnClick="refresh" />
            </el-tab-pane>

            <el-tab-pane :label="$t('contacts_hub.menu.contacts.title')" name="2">
              <div class="container-inner">
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('contacts_hub.menu.suggestions.title')" name="3">
              <div class="container-inner">
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </transition> -->
    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import ChatPanel from "../modules/ChatPanel";
import Contacts from "../components/event/Contacts";
import Suggestions from "../components/event/Suggestions.vue";
import InfiniteLoading from "vue-infinite-loading";
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import NoData from "@/modules/NoData";

export default {
  name: "MessagesDialog",

  components: {
    InfiniteLoading,
    ChatPanel,
    Contacts,
    NoData,
    LottieAnimation,
    Suggestions
  },

  data() {
    return {
      messages: [],
      messageIdentifier: +new Date(),

      activeChats: null,
      activeTab: "1",
      moment,
      user: null,
      loading: false,
      timeout: null,
      chatloading: false,
      messageBlock: false,
      error: {
        message: null,
        hasError: false
      }
    };
  },
  created() {
    this.$store.state.chats = [];
  },
  computed: {
    innerWidth() {
      return window.innerWidth;
    },

    getMessages() {
      return _.orderBy(this.$store.state.chats, ["lastMessage.createDate"], ["desc"]);
    }
  },
  methods: {
    refresh() {
      this.loading = "message";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.$store.state.chats = [];
        this.messageIdentifier += 1;
        this.loading = false;
      }, 500);
    },
    handleClick(tab, event) {},

    close(id) {
      this.activeChats = null;
    },
    getChatUser(chat) {
      return chat.recipients.find(k => k.userID != this.$store.state.user.id);
    },
    activateChat(chat) {
      if (this.chatloading == false) {
        this.activeChats = null;
        this.chatloading = true;

        setTimeout(() => {
          this.activeChats = chat.id;
          this.chatloading = false;
          this.$store.state.chats.find(k => k.id == chat.id).unread = 0;
          this.$store.state.chats.find(k => k.id == chat.id).messages = [];
          this.$store.state.unreadMessages = 0;
        }, 300);
      }
    },
    async getData($state) {
      var response = await axios.post("Chat/ListMessageGroups", {
        skip: this.$store.state.chats.length,
        take: 10
      });

      var data = response.data.data.items.map(i => {
        i = {
          ...i,
          isActive: false,
          minimized: true,
          messages: []
        };
        return i;
      });

      this.$store.state.chats = [...this.$store.state.chats, ...data];
      if (response.data.data.items.length == 0) $state.complete();
      else $state.loaded();
    }
  }
};
</script>

<style lang="less">
#messages-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 0;

  .md-tabs-navigation {
    border-bottom: 1px solid #f1f3f6;
  }

  .md-button-content {
    font-size: 16px;
  }

  .contacts-container-inner {
    overflow: hidden;
    overflow-y: scroll;
    max-height: 520px;
  }

  .messages-container {
    max-height: 600px;
    width: 100%;
    .tab-switch {
      background: #ffffff;
      padding: 8px;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 48px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 8px;
      margin-bottom: 1rem;
      & > .tab-item {
        border-radius: 48px;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        cursor: pointer;
        letter-spacing: 0.2px;
        color: #505763;
        transition: all 0.5s;
        height: 32px;
        display: flex;
        justify-content: center;
        &.active {
          background: #268ea6;
          color: #ffffff;
        }
      }
    }
    .message-hub {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 16px;

      .messaging-panel {
        width: 100%;
        max-width: 320px;
        min-width: 320px;
        height: 423px;
        overflow: hidden;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        position: relative;
        padding-right: 8px;
        gap: 10px;

        .messaging-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          padding: 10px;
          border-bottom: 1px solid #f1f3f6;
          background: #e8ebef;
          border-radius: 12px;
          gap: 10px;
          cursor: pointer;

          &:last-child {
            border-bottom: none !important;
          }

          .messaging-profile-picture {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 50%;
            border: 2px solid #fff;
            width: 48px;
            flex-shrink: 0;
            height: 48px;
            display: inline-block;
          }

          .messaging-right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .messaging-user-name {
              font-size: 14px;
              font-weight: 500;
              white-space: nowrap;
              color: #292f3b;
              margin: 0;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              line-height: 20px;
              display: flex;
              align-items: center;

              span {
                background-color: #268ea6;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                font-weight: 700;
                font-size: 14px;
                display: block;
                line-height: 20px;
                color: white;
                font-size: 12px;
                text-align: center;
                margin-left: 6px;
              }
            }

            .messaging-last-message {
              font-size: 12px;
              color: #505763;
              line-height: 18px;
              font-weight: 400;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              margin: 0;
            }

            .messaging-moment {
              font-size: 12px;
              font-weight: 400;
              color: #8c929c;
              margin: 0;
              line-height: normal;
            }
          }
        }
      }
      .chat-border {
        height: 423px;
        width: 1px;
        background-color: #c8cdd3;
        flex-shrink: 0;
        @media screen and (max-width: 768px) {
          display: none;
        }
      }
      .chat-panel-container {
        width: 100%;
        height: 423px;

        .no-active-chat {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 100%;
          height: 100%;

          i {
            color: #50bfbf;
            font-size: 80px;
          }

          p {
            color: #505763;
            font-weight: 500;
            font-size: 18px;
          }
        }
      }
    }
  }
}

.custom-messages-dialog {
  &.mobile-dialog {
    .el-dialog {
      min-width: unset;
      .modal-body {
        &.messages {
          width: 100%;
        }
      }
    }
  }
  .el-dialog {
    width: calc(~"100% - 20px");
    max-width: calc(~"900px - 20px");
    min-width: 520px;
    .modal-body {
      width: 100%;
      &.messages {
        overflow: hidden;
        overflow-y: hidden;
        overflow-x: hidden;
      }
    }
  }
}

@media (max-width: 768px) {
  #messages-dialog {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 0;
    .contacts-container-inner {
      max-height: calc(~"100vh - 180px");
      width: 100%;
    }

    .contacts-container {
      padding: 0px !important;
    }

    .messages-container {
      max-height: calc(~"100vh - 224px");
      min-width: unset;

      .message-hub {
        .messaging-panel {
          width: 100%;
          max-width: unset;
          min-width: unset;
          padding: 0 !important;
          height: calc(~"100vh - 290px");
        }
        .chat-panel-container {
          max-width: unset;
          width: 100%;
          min-width: unset;
          .chat-panel {
            height: calc(~"100% - 92px");
            & > .messages {
              height: unset;
              flex-grow: 1;
            }
          }
        }
      }

      .mobile-chat-passive {
        display: none !important;
      }

      .mobile-chat-active {
        display: none !important;
      }
    }
  }

  .custom-messages-dialog {
    .md-dialog-container .md-tab {
      padding: 11px;
    }

    .md-dialog-container {
      max-height: 100% !important;
      max-width: 100% !important;
      min-width: 100% !important;
      border-radius: 0px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MessagesDialog.vue